enum StatisticsButtonType {
  Mail = 'mail',
  Reset = 'reset',
}

export default StatisticsButtonType;
